/**
 * How We Worked It Out Page Wrapper for PDF Generation
 * 
 * Wraps the HowWeWorkedItOut component with the dp-page class for print styling consistency
 */

import { HowWeWorkedItOut } from '@system-rec/decision-ui';
import type { HowWeWorkedItOutProps } from '@system-rec/decision-ui';

export function HowWeWorkedItOutWrapper(props: HowWeWorkedItOutProps) {
  return (
    <div className="dp-page how-we-worked-it-out-wrapper">
      <HowWeWorkedItOut {...props} />
    </div>
  );
}
